import { supabase } from "lib/supabaseClient";

// ─── Always fetch fresh from DB (no cache) ─────────────────
export const getCurrentActor = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;
    const { data: p } = await supabase
      .from("employees")
      .select("full_name, employee_number, role")
      .eq("id", user.id)
      .single();
    return {
      id:     user.id,
      name:   p?.full_name       || user.email || "Unknown",
      number: p?.employee_number || "—",
      role:   p?.role            || "employee",
    };
  } catch { return null; }
};

// ─── Core insert ───────────────────────────────────────────
export const insertLog = async (logEntry) => {
  try {
    // Auto-fill actor info if not provided
    let actor = { name: logEntry.actor_name, number: logEntry.actor_number, role: logEntry.actor_role };
    if (!actor.name || actor.number === "—" || !actor.number) {
      const fresh = await getCurrentActor();
      if (fresh) {
        actor.name   = actor.name   || fresh.name;
        actor.number = (!actor.number || actor.number === "—") ? fresh.number : actor.number;
        actor.role   = actor.role   || fresh.role;
      }
    }

    const { error } = await supabase.from("security_logs").insert([{
      timestamp:     logEntry.timestamp     || new Date().toISOString(),
      actor_name:    actor.name             || "Unknown",
      actor_number:  actor.number           || "—",
      actor_role:    actor.role             || "employee",
      target_id:     logEntry.target_id     || null,
      target_name:   logEntry.target_name   || null,
      target_number: logEntry.target_number || null,
      action:        logEntry.action        || "ACTION",
      details:       logEntry.details       || "",
    }]);
    if (error) console.error("[logService] error:", error.message);
  } catch (err) {
    console.error("[logService] exception:", err.message);
  }
};

// ─── Quick log — auto fetches actor ────────────────────────
export const quickLog = async (action, details, extra = {}) => {
  const actor = await getCurrentActor();
  if (!actor) return;
  await insertLog({
    timestamp:    new Date().toISOString(),
    actor_name:   actor.name,
    actor_number: actor.number,
    actor_role:   actor.role,
    action,
    details,
    ...extra,
  });
};

// ─── Fetch all logs ────────────────────────────────────────
export const getAllLogs = async () => {
  const { data, error } = await supabase
    .from("security_logs")
    .select("*")
    .order("timestamp", { ascending: false });
  if (error) throw error;
  return data;
};

// ─── Fetch logs for specific employee ─────────────────────
export const getEmployeeLogs = async (employeeId) => {
  const { data, error } = await supabase
    .from("security_logs")
    .select("*")
    .eq("target_id", employeeId)
    .order("timestamp", { ascending: false });
  if (error) throw error;
  return data;
};
